import { Grid } from "@mui/material";
import { SiteHeader } from "src/containers/SiteHeader/SiteHeader";
import { Footer } from "../../containers/Footer/Footer";
import { Advantages } from "./containers/Advantages/Advantages";
import { Comparison } from "./containers/Comparison/Comparison";
import { Cta } from "./containers/Cta/Cta";
import { Flow } from "./containers/Flow/Flow";
import { Hero } from "./containers/Hero/Hero";
import { Introduction } from "./containers/Introduction/Introduction";
import { Overview } from "./containers/Overview/Overview";
import { Pricing } from "./containers/Pricing/Pricing";
import { Security } from "./containers/Security/Security";
import { Services } from "./containers/Services/Services";
import { Sla } from "./containers/Sla/Sla";
import { Strengths } from "./containers/Strengths/Strengths";
import { useEffect } from "react";

export const AmspPage = () => {
  // ひとまず暫定でタイトルを設定
  // MEMO: 他のメタタグも含め、 SSG で設定したい
  useEffect(() => {
    document.title = "Advanced Managed Service Provider (AMSP) | 株式会社テクノスタンダード";
  }, []);

  return (
    <Grid
      container
      className="AmspPage"
      sx={{
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
        minWidth: {
          md: "768px",
          xs: "374px",
        },
      }}
    >
      <SiteHeader />
      <Hero />
      <Overview />
      <Strengths />
      <Comparison />
      <Flow />
      <Services />
      <Pricing />
      <Sla />
      <Security />
      <Introduction />
      <Advantages />
      <Cta />
      <Footer />
    </Grid>
  );
};
